import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { GradeSubjectService } from 'src/app/service/grade-subject.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
@Component({
  selector: 'app-grade-subject-update',
  templateUrl: './grade-subject-update.component.html',
  styleUrls: ['./grade-subject-update.component.scss']
})
export class GradeSubjectUpdateComponent implements OnInit {

 
  showLoader: boolean = false;
  creating: boolean = false;
  semesters: any;
  batches: any;
  courses: any;
  gradeSubId: any;
  
  ShowFilter = true;


  
 currentGradeSubject:any;
 currentSemester:any;
 currentBatch:any;
 currentCoure:any;

  updateGradeSubject = new FormGroup({
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,]),
    course: new FormControl('', [
      Validators.required,]),
    note: new FormControl('', [
      Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),
    
  }, []);

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private coursesService: CoursesService
    , private gradeSubjectService: GradeSubjectService
  ) {

  }

  ngOnInit(): void {
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.gradeSubId = params['gradeSubId'] || "";

        if (this.gradeSubId != "") {
          this.showLoader = true;
          this.getGradeSubjectById();
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE_ROLE'));
          this.router.navigate(['/enrolment/courses']);
        }
      });
    
    
  }
  getGradeSubjectById(){
    this.gradeSubjectService.getGradeSubjectById(this.gradeSubId)
    .subscribe(
      data => {
        console.log(data);
          this.currentGradeSubject=data;
          this.getSemesterById(data);
        
      },
      error => {
        this.creating = false;
        this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
      }
    );

  }

  getSemesterById(basicdata:any){
    this.gradeSubjectService.getSemesterById(basicdata.abrivid)
    .subscribe(
      data => {
        console.log(data);
        this.currentSemester=data;
        this.getBatchById(basicdata);
        
      },
      error => {
        this.creating = false;
        this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
      }
    );

  }

  getBatchById(basicdata:any){
    this.gradeSubjectService.getBatchById(basicdata.gradeid)
    .subscribe(
      data => {
        console.log(data);
        this.currentBatch=data;
        this.getCourseById(basicdata);
        
      },
      error => {
        this.creating = false;
        this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
      }
    );

  }
  getCourseById(basicdata:any){
    this.coursesService.getCourseById(basicdata.subjectid)
    .subscribe(
      data => {
        console.log(data);
        this.currentCoure=data;
        this.updateGradeSubject.controls.semester.setValue(this.currentSemester.abrivNameEn);
        this.updateGradeSubject.controls.batch.setValue(this.currentBatch.gradeNameEn);
        this.updateGradeSubject.controls.course.setValue(this.currentCoure.subjectNameEn+"-("+this.currentCoure.subjectCode+")");
        this.updateGradeSubject.controls.note.setValue(this.currentGradeSubject.notes);
        this.updateGradeSubject.controls.active.setValue(this.currentGradeSubject.active);
        this.showLoader = false;
        
      },
      error => {
        this.creating = false;
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );

  }

  updateGradeSubjectChange() {

  }

  updateGradeSubjectSubmit() {
    if (this.updateGradeSubject.valid) {
      // call your service 
      let active = this.updateGradeSubject.controls.active.value;
      let note = this.updateGradeSubject.controls.note.value;
      
      this.updateStatusGradeSubject(this.currentGradeSubject.id,active,note)
    }
    else {
      this.updateGradeSubject.markAllAsTouched();
      this.updateGradeSubject.markAsDirty();
    }
  }

  updateStatusGradeSubject(id: any,active: string,note:string) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;

    this.gradeSubjectService.updateGradeSubjectStatus(username, id, active,note)
      .subscribe(
        data => {
          console.log(data);
          this.creating = false;
            this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
            this.router.navigate(['/enrolment/grade-subject']);
          
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
        }
      );
  }


  getAllData() {
    this.showLoader = true;
    this.gradeSubjectService.getAllsemesters().subscribe(
      data => {
        this.semesters = data;
        console.log("sem"+this.semesters)
        this.gradeSubjectService.getALLBatches().subscribe(
          data => {
            this.batches = data;
            this.coursesService.getAllCourses().subscribe(
              data => {
                this.courses = data;
                this.showLoader = false;
              },
              error => {
                this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
                this.showLoader = false;
              }
            );
          },
          error => {
            this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
            this.showLoader = false;
          }
        );
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
        this.showLoader = false;
      }
    );

  }

  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

}

